import { render, staticRenderFns } from "./emptySales.vue?vue&type=template&id=1cfd36f2&scoped=true&"
import script from "./emptySales.vue?vue&type=script&lang=js&"
export * from "./emptySales.vue?vue&type=script&lang=js&"
import style0 from "./emptySales.vue?vue&type=style&index=0&id=1cfd36f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfd36f2",
  null
  
)

export default component.exports